import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarSquareRegularAgendaIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 5.2Q12 4.1 11 4 9.8 4 9.7 5.2v2H8.1A3 3 0 0 0 5 10.4v14.4C5 26.6 6.4 28 8.1 28H24c1.7 0 3.1-1.4 3.1-3.2V10.4c0-1.8-1.4-3.2-3.1-3.2h-1.6v-2q0-1.1-1.2-1.2-1 0-1.2 1.2v2h-7.8zm9.1 4.4H24q.7.1.7.8v14.4q0 .7-.7.8H8a1 1 0 0 1-.7-.8V10.4q0-.7.7-.8zM9.7 16.4q0 1.1 1.2 1.2H21q1.1 0 1.2-1.2T21 15.2H11q-1.1 0-1.2 1.2M11 20q-1.1 0-1.2 1.2t1.2 1.2h5.5q1 0 1.2-1.2-.2-1.1-1.2-1.2z" })
});
export default SvgCalendarSquareRegularAgendaIcon;
